// import { Link } from "react-router-dom";
// import { useEffect, useState } from "react";

// function Home() {
//   const [movies, setMovies] = useState([]);
//   const [politics, setPolitics] = useState([]);
//   const [reviews, setReviews] = useState([]);
//   const [collections, setCollections] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [ott, setOtt] = useState([]);

//   useEffect(() => {
//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=movies")
//       .then((res) => res.json())
//       .then((data) => setMovies(data))
//       .catch(() => setMovies([]));

//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=politics")
//       .then((res) => res.json())
//       .then((data) => setPolitics(data))
//       .catch(() => setPolitics([]));


//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=review")
//       .then(res => res.json())
//       .then(setReviews)
//       .catch(() => setReviews([]));

//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=collection")
//       .then(res => res.json())
//       .then(setCollections)
//       .catch(() => setCollections([]));

//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=header")
//       .then(res => res.json())
//       .then(setHeaders)
//       .catch(() => setHeaders([]));


//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=ott")
//       .then(res => res.json())
//       .then(setOtt)
//       .catch(() => setOtt([]));

//   }, []);

//   return (
//     <div className="container mt-4">
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

function Home() {
  const [movies, setMovies] = useState([]);
  const [politics, setPolitics] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [collections, setCollections] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [ott, setOtt] = useState([]);

  const [loading, setLoading] = useState(true);   // ✅ loading state
  const [isMobile, setIsMobile] = useState(false);
  const [mobileImages, setMobileImages] = useState([]);
  const [desktopImages, setDesktopImages] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [m, p, r, c, h, o] = await Promise.all([
          fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=movies").then(res => res.json()).catch(() => []),
          fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=politics").then(res => res.json()).catch(() => []),
          fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=review").then(res => res.json()).catch(() => []),
          fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=collection").then(res => res.json()).catch(() => []),
          fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=header")
            .then((res) => res.json())
            .then((data) => {
              setMobileImages(data.filter((i) => i.imagetype === "mobile"));
              console.log(mobileImages)
              setDesktopImages(data.filter((i) => i.imagetype === "desktop"));
              console.log(desktopImages)
            })
            .catch(() => {
              setMobileImages([]);
              setDesktopImages([]);
            }),
          fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=ott").then(res => res.json()).catch(() => []),
        ]);

        setMovies(m);
        setPolitics(p);
        setReviews(r);
        setCollections(c);
        setHeaders(h);
        setOtt(o);

      } finally {
        setLoading(false);   // ✅ stop loading after all fetches
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const check = () => setIsMobile(mq.matches);

    check(); // set initial
    mq.addEventListener("change", check);

    return () => mq.removeEventListener("change", check);
  }, []);
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };


  // ======================== LOADING UI ========================
  if (loading) {
    return (
      <div className="container text-center mt-5">
        <span style={{ fontSize: "3rem" }}>⏳ Loading...</span>
        {/* <p>Please wait while we fetch the latest content.</p> */}
      </div>
    );
  }
  // ============================================================
  const imagesToShow = isMobile ? mobileImages : desktopImages;
  console.log(imagesToShow)
  return (
    <div className="container mt-4">

      {/* Carousel */}
      {/* <div id="homeCarousel" className="carousel slide mb-4" data-bs-ride="carousel">
      <div className="carousel-inner">
        {headers.length > 0 ? (
          headers.map((h, index) => (
            <div
              key={h._id}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={h.imageUrl}
                className="d-block w-100"
                alt={h.title}
                style={{ height: 400, objectFit: "cover" }}
              />


              <div className="carousel-caption d-none d-md-block">
                <h5>{h.title}</h5>
                <p>{h.content.slice(0, 80)}...</p>
              </div>
            </div>
          ))
        ) : (
          <>
            <div className="carousel-item active">
              <img
                src="https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?w=1200"
                className="d-block w-100"
                alt="Movies Slide"
                style={{ height: 300, objectFit: "cover" }}
              />
              <div className="carousel-caption d-none d-md-block">
                <h5>Welcome to MoviePolitical</h5>
                <p>Movie reviews & political analysis in one place.</p>
              </div>
            </div>

            <div className="carousel-item">
              <img
                src="https://images.unsplash.com/photo-1550583724-b2692b85b150?w=1200"
                className="d-block w-100"
                alt="Cinema Slide"
                style={{ height: 300, objectFit: "cover" }}
              />
              <div className="carousel-caption d-none d-md-block">
                <h5>Behind the Scenes</h5>
                <p>Exclusive looks at filmmaking and box office trends.</p>
              </div>
            </div>

            <div className="carousel-item">
              <img
                src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1200"
                className="d-block w-100"
                alt="Politics Slide"
                style={{ height: 300, objectFit: "cover" }}
              />
              <div className="carousel-caption d-none d-md-block">
                <h5>Politics & Society</h5>
                <p>Latest insights and analyses on current affairs.</p>
              </div>
            </div>
          </>
        )}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div> */}
      <div id="homeCarousel" className="carousel slide mb-4" data-bs-ride="carousel">
        <div className="carousel-inner">

          {imagesToShow.length > 0 ? (
            imagesToShow.map((h, index) => (
              <div
                key={h._id}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                <img
                  src={h.imageUrl}
                  className="d-block w-100"
                  alt={h.title}
                  style={{ height: 400, objectFit: "cover" }}
                />

                {/* <div className="carousel-caption d-none d-md-block">
                <h5>{h.title}</h5>
                <p>{h.content.slice(0, 80)}...</p>
              </div> */}
              </div>
            ))
          ) : (
            <>
              {/* FALLBACK SLIDES */}
              <div className="carousel-item active">
                <img
                  src="https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?w=1200"
                  className="d-block w-100"
                  alt="Movies Slide"
                  style={{ height: 300, objectFit: "cover" }}
                />
                <div className="carousel-caption d-none d-md-block">
                  <h5>Welcome to TalkieTalks</h5>
                  <p>Movie reviews & political analysis in one place.</p>
                </div>
              </div>

              <div className="carousel-item">
                <img
                  src="https://images.unsplash.com/photo-1550583724-b2692b85b150?w=1200"
                  className="d-block w-100"
                  alt="Cinema Slide"
                  style={{ height: 300, objectFit: "cover" }}
                />
                <div className="carousel-caption d-none d-md-block">
                  <h5>Behind the Scenes</h5>
                  <p>Exclusive looks at filmmaking and box office trends.</p>
                </div>
              </div>

              <div className="carousel-item">
                <img
                  src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1200"
                  className="d-block w-100"
                  alt="Politics Slide"
                  style={{ height: 300, objectFit: "cover" }}
                />
                <div className="carousel-caption d-none d-md-block">
                  <h5>Politics & Society</h5>
                  <p>Latest insights and analyses on current affairs.</p>
                </div>
              </div>
            </>
          )}
        </div>

        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>


      <div className="d-flex justify-content-center mb-4">
        <div className="row w-100" style={{ maxWidth: 1200 }}>
          {/* ✅ Latest Movie Articles */}
          <div className="col-md-6 mb-4">
            <div className="p-3 shadow rounded bg-white floating-box h-100">
              <div
                className="text-center mb-3 p-2 rounded fw-bold"
                style={{ backgroundColor: "#f0f5ff", color: "#003366" }}
              >
                Latest Movie Articles
              </div>
              {movies.length === 0 ? (
                <p>No movie articles</p>
              ) : (
                movies
                  .filter(a => a.type !== "header" && a.type !== "ott")   // ✅ remove header items
                  .slice(0, 3)                        // ✅ then take first 3
                  .map((a) => (
                    <Link
                      to={`/article/${a._id}`}
                      key={a._id}
                      className="text-decoration-none"
                    >
                      <div className="card mb-2 p-2 article-card">
                        <h6 className="mb-1 fw-bold">{a.title}</h6>
                        {/* <p className="mb-0 text-muted">{a.content.slice(0, 120)}...</p> */}
                        <p className="mb-0 text-muted">
                          {stripHtml(a.content).slice(0, 120)}...
                        </p>

                      </div>
                    </Link>
                  ))
              )}

              {/* ✅ More link */}
              <div className="text-end mt-2">
                <Link to="/movies" className="fw-bold text-primary text-decoration-none">
                  More →
                </Link>
              </div>
            </div>
          </div>

          {/* ✅ Latest Political Articles */}
          <div className="col-md-6 mb-4">
            <div className="p-3 shadow rounded bg-white floating-box h-100">
              <div
                className="text-center mb-3 p-2 rounded fw-bold"
                style={{ backgroundColor: "#f0f5ff", color: "#003366" }}
              >
                Latest NEWS Articles
              </div>

              {politics.length === 0 ? (
                <p>No NEWS articles</p>
              ) : (
                politics.slice(0, 3).map((a) => (
                  <Link
                    to={`/article/${a._id}`}
                    key={a._id}
                    className="text-decoration-none"
                  >
                    <div className="card mb-2 p-2 article-card">
                      <h6 className="mb-1 fw-bold">{a.title}</h6>
                      <p className="mb-0 text-muted">{a.content.slice(0, 120)}...</p>
                    </div>
                  </Link>
                ))
              )}

              {/* ✅ More link */}
              <div className="text-end mt-2">
                <Link to="/politics" className="fw-bold text-primary text-decoration-none">
                  More →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="d-flex justify-content-center">
        <div className="row w-100" style={{ maxWidth: 1200 }}>
          <div className="col-md-4 mb-4">
            <div className="p-3 shadow rounded bg-white floating-box h-100">
              <h4 className="text-center mb-3 p-2 rounded fw-bold bg-primary text-white">
                Reviews
              </h4>
              {reviews.length === 0 ? (
                <p>No reviews</p>
              ) : (
                reviews.slice(0, 3).map((r) => (
                  <Link to={`/article/${r._id}`} key={r._id} className="text-decoration-none">
                    <div className="card mb-2 p-2 article-card">
                      <h6 className="mb-1">{r.title}</h6>
                      {/* <p className="mb-0 text-muted">{r.content.slice(0, 80)}...</p> */}
                       <p className="mb-0 text-muted">
                          {stripHtml(r.content).slice(0, 120)}...
                        </p>
                    </div>
                  </Link>
                ))
              )}
              <div className="text-end mt-2">
                <Link to="/Reviews" className="fw-bold text-primary">More →</Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="p-3 shadow rounded bg-white floating-box h-100">
              <h4 className="text-center mb-3 p-2 rounded fw-bold bg-success text-white">
                GBOC & Footfalls
              </h4>
              {collections.length === 0 ? (
                <p>No data</p>
              ) : (
                collections.slice(0, 3).map((r) => (
                  <Link to={`/article/${r._id}`} key={r._id} className="text-decoration-none">
                    <div className="card mb-2 p-2 article-card">
                      <h6 className="mb-1">{r.title}</h6>
                      <p className="mb-0 text-muted">{r.content.slice(0, 80)}...</p>
                    </div>
                  </Link>
                ))
              )}
              <div className="text-end mt-2">
                <Link to="/Collections" className="fw-bold text-success">More →</Link>
              </div>
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="p-3 shadow rounded bg-white floating-box h-100">
              <h4 className="text-center mb-3 p-2 rounded fw-bold bg-warning text-dark">
                New OTT Releases
              </h4>
              <table className="table table-borderless">
                <thead>
                  <tr>
                    <th>Movie</th>
                    <th>OTT Release Date</th>
                    <th>Platform</th>
                  </tr>
                </thead>
                <tbody>
                  {ott.map(o => (
                    <tr key={o._id}>
                      <td>{o.movie}</td>
                      <td>{o.releaseDate}</td>
                      <td>{o.platform}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="text-end mt-2">
                <Link to="/ott" className="fw-bold text-warning">More →</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
